import React from 'react'


export const PortfolioCard = (props) => {
    return (
        <>
            <div className="cardbg d-flex-center col-2" data-aos="fade">
                <div className="card">
                    <div className="d-flex-center flex-direction-column">
                        <div className="cardImg">
                            <img src={props.cardImg} alt="" />
                        </div>
                        <div className="cardTitle">
                            <h4>{props.cardTitle}</h4>
                        </div>
                        <div className="cardP">
                            <p>{props.cardSpecify}</p>
                        </div>
                    </div>
                    <div className="portfolioCard-bottom">
                        <div className="card-skills">
                            <box-icon color='var(--font-color)' size="sm" type='logo' name={props.skill_1}></box-icon>
                            <box-icon color='var(--font-color)' size="sm" type='logo' name={props.skill_2}></box-icon>
                            <box-icon color='var(--font-color)' size="sm" type='logo' name={props.skill_3}></box-icon>
                        </div>
                        <div className="siteurl">
                            <a href={props.url} className="card-external-link" rel="noreferrer" target="_blank">View site&nbsp;<box-icon name='link-external' color='var(--font-color)' ></box-icon></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
